import { ISettingState, actionTypes } from 'src/ducks/setting.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getSettingStatus = (
  state: ISettingState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
